import { render, staticRenderFns } from "./OpenEyes.vue?vue&type=template&id=b3c68f30&scoped=true&"
import script from "./OpenEyes.vue?vue&type=script&lang=js&"
export * from "./OpenEyes.vue?vue&type=script&lang=js&"
import style0 from "./OpenEyes.vue?vue&type=style&index=0&id=b3c68f30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c68f30",
  null
  
)

export default component.exports